module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./BankSearchView.js"));
	}, "BankSearchView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BankSearchView!./src/pages/Register/BankSearch/BankSearchView.js
// module id = 184
// module chunks = 418